module.exports = __webpack_public_path__ + "img/qu_gb-wls.f522987.jpg";